import { Component, OnInit } from "@angular/core";
import { PlayerService } from "../../core/services/player/player.service";
import { NgxLinkifyOptions } from "ngx-linkifyjs";
import { environment } from "../../../../environments/environment";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { ArchiveService } from "../../../services/archive.service";
import {
  ArchiveCategory,
  FilterQuery,
  FilterItem,
  Show,
} from "../../../services/archive.model";

@Component({
  selector: "psr-player",
  templateUrl: "./player.component.html",
  styleUrls: ["./player.component.scss"],
})
export class PlayerComponent {
  public isMobile: boolean = window.innerWidth <= 900;
  public safeScUrl: SafeResourceUrl = null;
  public currentlyPlaying: Show = null;
  public showingInfo = false;
  public showingBigMobilePlayer = false;
  public showCurtain = true;
  private filter: FilterQuery;
  public linkifyOptions: NgxLinkifyOptions = {
    target: {
      url: "_blank",
    },
    format(value: string, type: string): any {
      if (type === "url") {
        value = value
          .replace("https://", "")
          .replace("http://", "")
          .replace("www.", "");
      }

      return value;
    },
  };

  public getCatQueryParams(cat: ArchiveCategory) {
    return { [cat.type]: cat.name };
  }

  getScIframeUrl(show: Show) {
    const url =
      "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/" +
      show.soundcloud_upload_id +
      "&color=%23000000&auto_play=true&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false&visual=true";

    return this._sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  constructor(
    private archiveService: ArchiveService,
    private playerService: PlayerService,
    protected _sanitizer: DomSanitizer,
  ) {
    this.archiveService.activeFilter.subscribe((filter) => {
      this.filter = filter;
    });
    this.playerService.currentlyPlaying.subscribe((show) => {
      this.currentlyPlaying = show;
      this.safeScUrl = this.getScIframeUrl(show);

      if (!!this.currentlyPlaying) {
        document.body.classList.add("mobile-player-visible");
        if (!this.playerEnabled) {
          this.showBigMobilePlayer();
        }
      } else {
        document.body.classList.remove("mobile-player-visible");
      }
    });
    this.playerService.showingInfo.subscribe(
      (showingInfo) => (this.showingInfo = showingInfo),
    );
    this.playerService.isPlaying.subscribe((isPlaying) => {
      if (!isPlaying) {
        this.closePlayer();
      }
    });
  }

  isActiveCat(cat: ArchiveCategory) {
    if (this.filter === undefined) {
      return false;
    }

    if (this.filter[cat.type] === undefined || this.filter[cat.type] === null) {
      return false;
    }

    if (!!this.filter[cat.type].id) {
      return this.filter[cat.type].id === cat.id;
    }

    return false;
  }

  public playerEnabled = !(
    window.location.hostname === environment.iOSAppDomain
  );

  closePlayer(): void {
    this.playerService.pause();
    this.playerService.currentlyPlaying.next(null);
  }

  showBigMobilePlayer(): void {
    document.body.classList.add("no-scroll");
    this.showingBigMobilePlayer = true;
  }

  hideBigMobilePlayer(): void {
    document.body.classList.remove("no-scroll");
    this.showingBigMobilePlayer = false;

    if (!this.playerEnabled) {
      this.currentlyPlaying = null;
    }
  }

  handleInfoScroll($event): void {
    const el = $event.target;
    this.showCurtain = el.scrollHeight - el.scrollTop - 10 >= el.clientHeight;
  }

  toggleCategoryFilter(cat: ArchiveCategory) {
    // Create a new filter query based on the current one
    const newFilter: FilterQuery = {
      mood: this.filter.mood,
      flavor: this.filter.flavor,
      location: this.filter.location,
    };

    // Toggle the clicked category
    if (this.isActiveCat(cat)) {
      // If active, remove it
      newFilter[cat.type] = null;
    } else {
      // If not active, add it
      const filterItem: FilterItem = {
        id: cat.id,
        name: cat.name,
      };
      newFilter[cat.type] = filterItem;
    }

    // Update the filter
    this.archiveService.search(newFilter);
  }
}
